import { MutableRefObject, useRef } from 'react';

import { NwExternalPaymentsServicesTypes } from '../../services/NwExternalPaymentsServices/APIService';
import { NwExternalPaymentsServices } from '../../services/NwExternalPaymentsServices/APIService/index.api';
import { networkCallWithApisauceWithHeaders } from '../../utils/AuthAPIUtils';

import { usePaymentsRefreshAuthTokens } from '../usePaymentsRefreshAuthTokens';

interface NwExternalPaymentsServiceInstance {
  nwExternalPaymentsServiceInstance: NwExternalPaymentsServicesTypes;
}

const useNwExternalPaymentsService = (): NwExternalPaymentsServiceInstance => {
  const { refreshTokenApi, getRefreshToken, getAccessToken } =
    usePaymentsRefreshAuthTokens();
  const nwExternalPaymentsServiceRef: MutableRefObject<NwExternalPaymentsServicesTypes | null> =
    useRef(null);

  if (nwExternalPaymentsServiceRef.current === null) {
    nwExternalPaymentsServiceRef.current = new NwExternalPaymentsServices(
      networkCallWithApisauceWithHeaders({
        refreshAuthTokensAPI: refreshTokenApi,
        getAccessToken,
        getRefreshToken
      })
    );
  }

  return { nwExternalPaymentsServiceInstance: nwExternalPaymentsServiceRef.current };
};

export { useNwExternalPaymentsService };
